<script lang="ts">
	import { HelpCircle } from 'lucide-svelte';
	import type { Snippet } from 'svelte';
	import { createPopperActions } from 'svelte-popperjs';

	type Props = {
		children: Snippet;
		error?: string | string[];
		className?: string;
		disabled?: boolean;
	};
	const [popperRef, popperContent] = createPopperActions({
		placement: 'bottom',
		strategy: 'fixed'
	});
	const extraOpts = {
		modifiers: [{ name: 'offset', options: { offset: [0, 8] } }]
	};
	let { children, error = undefined, className = '', disabled = false }: Props = $props();
	let showTooltip = $state(false);
</script>

<div
	class:disabled
	class="bg-one relative rounded-lg border border-slate-400 dark:border-gray-700 px-3 pb-1 pt-1 transition-colors {!error
		? 'focus-within:!border-blue-500'
		: ''}  {className}"
	class:!border-danger={error}
>
	{#if children}
		{@render children()}
	{/if}

	{#if error}
		<button
			type="button"
			class="absolute right-1 top-1"
			use:popperRef
			onclick={() => (showTooltip = !showTooltip)}
		>
			<HelpCircle size={20} class="text-danger" />
		</button>
		{#if showTooltip}
			<div
				id="tooltip"
				class="rounded-base z-10 bg-one p-4 shadow-xl"
				use:popperContent={extraOpts}
			>
				{#if typeof error === 'string'}
					<p class="text-sm italic text-danger">{error}</p>
				{:else if Array.isArray(error)}
					{#each error as err}
						<p class="text-sm italic text-danger">{err}</p>
					{/each}
				{/if}
			</div>
		{/if}
	{/if}
</div>

<style lang="postcss">
	.disabled {
		@apply border-gray-300;
	}
</style>
